import React, { useState } from 'react';
import { Row, Col } from 'antd';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import TokenIcon from '../../../components/TokenIcon';
import CopyWrapper from '../../../components/CopyWrapper';
import formatCurrency from '../../../utils/currencyFormatter';
import { tokenNodeTypeObj, tokenTypeEnd } from '../../../utils/tokenNodeTypes';
import { ReactComponent as ArrowDown } from '../../../img/general-icon/arrow-down.svg';
import { ReactComponent as CopyGrayIcon } from '../../../img/default-svg/copy.svg';
import { ReactComponent as ArrowLong } from '../../../img/wallets/arrow-long.svg';
import { ReactComponent as ArrowLong1 } from '../../../img/wallets/arrow-long-1.svg';
import './AdminWalletItemV2.scss';

const getGeneralAmount = wallet => {
  if (wallet?.balances?.length > 0) {
    return wallet.balances.reduce((acc, cur) => acc + cur?.balance?.usd, 0);
  }
  return wallet?.balance?.usd || 0;
};

const getWalletSubAssets = wallet => {
  if (wallet?.balances?.length > 0) {
    return wallet.balances;
  }
  return [];
};

const AdminWalletItemV2 = ({ wallet }) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  const subAssets = getWalletSubAssets(wallet);
  const hasTokens = subAssets.length > 0;

  return (
    <Row align="middle" className={`admin-wallet-item-v2 ${!wallet.main ? 'admin-wallet-item-v2--secondary' : ''}`}>
      <Col
        span={1}
        className="admin-wallet-item-v2__arrow"
        onClick={() => hasTokens && setIsExpanded(prev => !prev)}
        style={{ cursor: hasTokens ? 'pointer' : 'default' }}
      >
        {hasTokens && (
          <ArrowDown
            style={{
              transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.3s',
            }}
          />
        )}
      </Col>

      <Col span={10} className="admin-wallet-item-v2__address">
        <TokenIcon tokenName={wallet?.chainSymbol} />
        <CopyWrapper copyContent={wallet?.address}>{wallet?.address}</CopyWrapper>
        <CopyWrapper copyContent={wallet?.address}>
          <CopyGrayIcon className="admin-wallet-item-v2__copy-icon" />
        </CopyWrapper>
      </Col>

      <Col span={4}>{formatCurrency(getGeneralAmount(wallet))}</Col>

      <Col span={5} className="admin-wallet-item-v2__date">
        {moment(wallet?.createdAt).format('MMM D, YYYY, HH:mm') || '-'}
      </Col>

      <Col span={4} className="admin-wallet-item-v2__status-col">
        <div
          className={`admin-wallet-item-v2__status ${
            wallet.main ? 'admin-wallet-item-v2__status--default' : 'admin-wallet-item-v2__status--secondary'
          }`}
        >
          {wallet.main ? t('default') : t('secondary')}
        </div>
      </Col>

      {isExpanded && hasTokens && (
        <div className="admin-wallet-item-v2__tokens">
          {subAssets.map((asset, index) => (
            <Row align="bottom" key={asset.currency?.id || index} className="admin-wallet-item-v2__token-row">
              <Col span={2} className="admin-wallet-item-v2__token-arrow">
                <ArrowLong />
              </Col>
              <Col span={8} className="admin-wallet-item-v2__token-name">
                <TokenIcon tokenName={asset?.currency?.name} />
                {asset?.currency?.name === 'Binance-Peg BTCB Token' ? 'BTCB' : asset?.currency?.name}{' '}
                {asset?.currency?.currencyType === 'token' ? tokenNodeTypeObj[asset?.currency?.nodeType] : null}
                {tokenTypeEnd(asset?.currency?.currencyType, asset?.currency?.nodeType, asset?.currency?.name)}
              </Col>
              <Col span={14} className="admin-wallet-item-v2__token-amount">
                <span>
                  {asset?.balance?.value} {asset?.currency?.name}
                </span>
                <span className="admin-wallet-item-v2__token-amount--usd">
                  ({formatCurrency(+asset?.balance?.usd)})
                </span>
              </Col>
            </Row>
          ))}
        </div>
      )}
    </Row>
  );
};

export default AdminWalletItemV2;
